// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__h1rNG","cell":"ColumnAccessor_cell__2UiCf","firstCellAccent":"ColumnAccessor_firstCellAccent__4tL7v"};